var KeySkills = {
    init: function() {
        KeySkills.bindSubjectSelect();
        KeySkills.bindTutorGroupSelect();
    },

    bindTutorGroupSelect: function() {
        $('#keySkillsTutorGroup').change(function() {
            window.location.href = '/key-skills?tutorGroup=' + $(this).val();
        });

        $('#keySkillsEditTutorGroup').change(function() {
            var select = $(this);
            var pupilSelect = $('#keySkillsEditPupil');
            var tutorGroupId = select.val();
            $.get('/tutor-groups/' + tutorGroupId + '?transform=1', function(data) {
                pupilSelect.empty();
                pupilSelect.select2({
                    data: data['items']
                });
            });
        });

        $('#keySkillsPupil').change(function() {
            var pupilId = $(this).val();
            var tutorGroupId = $('#keySkillsTutorGroup').val();
            var url = '/key-skills?tutorGroup=' + tutorGroupId + '&pupil=' + pupilId;

            if (pupilId == 'all') {
                url = '/key-skills?tutorGroup=' + tutorGroupId;
            }

            window.location.href = url;
        });
    },

    bindSubjectSelect: function() {
        $('.key-skills-subject').change(function() {
            var select = $(this);
            var subjectId = select.val();
            var targetId = select.data('target');
            var levelSelectId = select.data('level');
            var levelSelect = $('#' + levelSelectId);
            var queryString = '';
            var val = levelSelect.val();

            if (typeof(val) != 'undefined' && val != '' && val) {
                var levelId = val;
                queryString = '?levelId=' + levelId;
                var target = $('#' + targetId);
                target.empty();
                $.get('/admin/subjects/' + subjectId + '/statements' + queryString, function(data) {
                    target.select2({
                        data: data
                    });
                });
            }
        });

        $('.key-skills-level').change(function() {
            var select = $(this);
            var levelId = select.val();
            var targetId = select.data('target');
            var subjectSelectId = select.data('subject');
            var subjectSelect = $('#' + subjectSelectId);
            var queryString = '';
            var val = subjectSelect.val();

            if (typeof(val) != 'undefined' && val != '' && val) {
                var subjectId = val;
                queryString = '/statements?levelId=' + levelId;
                var target = $('#' + targetId);
                target.empty();
                $.get('/admin/subjects/' + subjectId + queryString, function(data) {
                    target.select2({
                        data: data
                    });
                });
            }
        });
    }
};